
// Components
import JumpcloudGoButton from 'client/components/JumpcloudGoButton.vue';
import JumpcloudGoPageLoader from 'client/components/JumpcloudGoPageLoader.vue';

// Libraries
import { defineComponent } from 'vue';

// Constants
import { durtApiResponseType, infoResponse } from 'client/services/durtConstants';
import LoginConsts from 'client/util/Constants/LoginConstants';
import MfaConstants from 'client/containers/Login/MfaConstants';

// Store
import { mapGetters } from 'vuex';

// Utils
import { useMfaLabels } from 'client/util/Constants/MfaLabels';
import Util from 'client/util/Util';
import durtService from 'client/services/durtService';

const { userConsoleRootRoute } = LoginConsts;
const { mfaNames } = MfaConstants;

export default defineComponent({
  name: 'JumpcloudGoHandler',

  components: {
    JumpcloudGoButton,
    JumpcloudGoPageLoader,
  },

  data() {
    return {
      durtInfo: {} as infoResponse,
      isLoading: false,
    };
  },

  props: {
    mfaType: {
      type: String,
      required: true,
    },
  },

  setup() {
    const mfaLabels = useMfaLabels();

    return {
      mfaLabels,
    };
  },

  computed: {
    ...mapGetters('StepUpModel', [
      'stateId',
    ]),

    headingText() {
      return this.mfaLabels.verifyIdentity;
    },

    isUvRequired() {
      return this.mfaType === mfaNames.durt_uv || !!this.durtInfo.is_locked;
    },

    userEmail(): string {
      return this.durtInfo.email || '';
    },
  },

  async created() {
    if (await durtService.hasExtension()) {
      this.initDurt();
    } else {
      this.handleError();
    }
  },

  methods: {
    async durtSignin() {
      try {
        const { isUvRequired, stateId } = this;
        this.setIsLoading(!this.isUvRequired);
        const accessData = await durtService.getAccess(isUvRequired, stateId);
        this.setIsLoading(true);

        // Wait 2s to allow JCGO animation enough time to render
        await Promise.all([durtService.signin(accessData), Util.delay(2000)]);
        this.$emit('success');
      } catch {
        this.handleError();
      }
    },

    handleError() {
      window.location.replace(`${userConsoleRootRoute}#/?error=goError`);
    },

    async initDurt() {
      try {
        this.durtInfo = await new Promise((resolve, reject) => {
          // rejects after 3 seconds of no response, avoiding WSOD
          setTimeout(reject, 3000);
          // resolve with getInfo response
          durtService.getInfo().then(resolve);
        });
      } catch {
        this.handleError();
      }

      if (this.durtInfo.result === durtApiResponseType.success) {
        this.durtSignin();
      } else {
        this.handleError();
      }
    },

    setIsLoading(value: boolean) {
      this.isLoading = value;
    },
  },
});
